'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagAsAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "#071585" }),
      /* @__PURE__ */ jsx("path", { d: "M28 20L0 9.99998L28 0V20Z", fill: "#D32636" }),
      /* @__PURE__ */ jsx("path", { d: "M28 1.2369L3.90153 9.99996L28 18.763V1.2369Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21.3333 9.38465C21.1754 9.22672 20.2589 9.59229 20.2589 9.59229L18.6666 8C18.6666 8 18.5845 7.11598 19.3333 6.66667C19.8996 6.32689 20.9606 6.45304 21.9986 6C23.6613 5.27433 25.3333 4 25.3333 4L24.2639 6.9408C24.2639 6.9408 25.4888 7.57232 25.3333 8C25.2882 8.12394 24.0926 8.51277 24 8.66667C23.8241 8.95909 24.6986 9.04774 24.4264 9.38465C23.6437 10.3533 22.6666 11.3333 22.6666 11.3333L21.3333 10.6667C21.3333 10.6667 21.5335 9.58484 21.3333 9.38465Z",
          fill: "#AB5423"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.1549 10.6666C19.2684 10.4705 19.3333 10.2428 19.3333 9.99998C19.3333 9.2636 18.7363 8.66665 18 8.66665C17.2636 8.66665 16.6666 9.2636 16.6666 9.99998C16.6666 10.2428 16.7316 10.4705 16.845 10.6666H16.6667C16.2985 10.6666 16 10.9651 16 11.3333C16 11.7015 16.2985 12 16.6667 12H20.0855L18.4041 12.7206C18.0657 12.8656 17.9089 13.2575 18.054 13.5959C18.199 13.9344 18.5909 14.0911 18.9293 13.9461L23.5834 11.9515C23.6132 11.9394 23.642 11.9252 23.6695 11.9092C23.7689 11.8513 23.8488 11.7704 23.9051 11.6764C23.9926 11.5303 24.0232 11.3525 23.9823 11.1801C23.9424 11.0103 23.8375 10.8655 23.6954 10.7734C23.5842 10.7017 23.4529 10.6638 23.3188 10.6666H19.1549Z",
          fill: "#FFC322"
        }
      )
    ]
  }
);
const VpFlagAsAsset = forwardRef(FlagAsAsset);

export { VpFlagAsAsset as default };
